import { useCallback, useState } from 'react'
import { showAlert } from '../../utility/SweetAlert'
import ApiService from '../../services/ApiService'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const InteractorFundBalanceHistoryList = () => {
  const { t } = useTranslation()
  const [fundHistoryData, setFundHistoryData] = useState([])
  const [fundBalanceHistoryPages, setFundBalanceHistoryPages] = useState({
    currentPage: 1,
    limitProduct: 0,
    totalPages: 1,
    totalItem: 0,
  })
  const { account } = useSelector((state) => state.account)

  const fundBalanceHistorySearch = useCallback(
    (payload, setLoading = () => {}) => {
      let payloadRequest = { ...payload, keywords: { source: 'SELLER', account_uid: account.uid } }
      setLoading(true)
      ApiService.jsonRequest('/fund-balance/history-search', payloadRequest, (response) => {
        setLoading(false)
        if (response.status_code === 200) {
          const { pages } = response.data
          setFundBalanceHistoryPages({
            currentPage: pages.page,
            limitProduct: pages.limit,
            totalPages: pages.total_pages,
            totalItem: pages.total_items,
          })
          let data = response.data?.items
          data = data.map((item) => {
            if (item.invoice_code && item.bill_to_name) {
              item.invoice = `No. Tagihan: ${item.invoice_code.trim()}, Ditagihkan ke: ${
                item.bill_to_name
              }`
            }
            return item
          })
          setFundHistoryData(data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
    },
    [account.uid, t],
  )

  return { fundHistoryData, fundBalanceHistorySearch, fundBalanceHistoryPages, setFundHistoryData }
}

export default InteractorFundBalanceHistoryList
